<template>
  <div class="qrcode-print-wrapper">
    <!-- 头部信息 -->
    <div class="header-section" align="center">
      <div class="title">检测报告</div>
      <img :src="imgUrl" class="qrcode-img"/>
    </div>
    <!-- 基础信息表格 -->
    <div class="basic-info-table">
      <table>
        <tbody>
        <tr v-for="(item, index) in tables1List" :key="index">
          <td class="basic-title-cell">{{ item.title }}</td>
          <td class="basic-content-cell">{{ item.content || '' }}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <!-- 报告编号 -->
    <div class="report-title">检测报告</div>
    <div class="report-number">报告编号：{{ tables1List[0].content || '' }}</div>
    <!-- 检测明细表格 -->
    <div class="detail-table-container">
      <table class="detail-table">
        <thead>
        <tr>
          <th width="3%">序号</th>
          <th width="7%">样品编号</th>
          <th width="7%">样品名称</th>
          <th width="12%">检测项目</th>
          <th width="6%">检测结果</th>
          <th width="6%">判断标准</th>
          <th width="6%">判定结果</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in tables2List" :key="index">
          <td align="center">{{ index + 1 }}</td>
          <td align="center">{{ item.sampleId || '' }}</td>
          <td align="center">{{ item.sampleName || '' }}</td>
          <td align="center">{{ item.testItem || '' }}</td>
          <td align="center">{{ item.testingResult || '' }}</td>
          <td align="center">{{ item.criteria || '' }}</td>
          <td align="center">{{ item.judgementResult || '' }}</td>
        </tr>
        </tbody>
      </table>
      <!-- 备注 -->
      <div class="remarks">
        <div>备注：</div>
        <div>1.本报告检测结果，仅供委托方内部食品安全质量控制用途，不具有法律效力。</div>
        <div>2.本报告仅对所检样品负责，检测结果仅对来样有效，委托方对样品的真实性负责。</div>
        <div>3.检测单位有权在完成报告后对样品进行处理。</div>
        <div>
          4.委托方对检测结果有异议，请于收到快速检测报告当天向检测单位申请复检。未经检测单位同意，本快速检测报告复印无效。
        </div>
      </div>
    </div>
  </div>
</template>
<script setup name="Qrcode">
import axios from 'axios'
import { ref } from 'vue'
import router from '@/router'

const { VUE_APP_API_URL } = process.env
const imgUrl = ref('')
const tables1List = ref([
  {
    title: '报告编号',
    content: null
  },
  {
    title: '委托方/受检方',
    content: null
  },
  {
    title: '委托方/受检方地址',
    content: null
  },
  {
    title: '委托方/受检方联系人',
    content: null
  },
  {
    title: '联系人电话',
    content: null
  },
  {
    title: '检测单位名称',
    content: null
  },
  {
    title: '仪器名称',
    content: null
  },
  {
    title: '仪器厂家',
    content: null
  },
  {
    title: '检测人员',
    content: null
  },
  {
    title: '审核人员',
    content: null
  },
  {
    title: '报告日期',
    content: null
  }
])
const tables2List = ref([])

function getData() {
  document.title = '报表信息'
  axios.get(`${VUE_APP_API_URL}/open/qrcode/${router.currentRoute.value.params.id}`)
    .then((response) => {
      const {
        qrcode,
        qrcodelist
      } = response.data.data
      imgUrl.value = qrcode.imgUrl
      tables1List.value[0].content = qrcode.reportNumber
      tables1List.value[1].content = qrcode.client
      tables1List.value[2].content = qrcode.clientAddress
      tables1List.value[3].content = qrcode.clientContacts
      tables1List.value[4].content = qrcode.contactNumber
      tables1List.value[5].content = qrcode.nameOfTestingUnit
      tables1List.value[6].content = qrcode.nameOfInstrument
      tables1List.value[7].content = qrcode.instrumentManufacturer
      tables1List.value[8].content = qrcode.inspector
      tables1List.value[9].content = qrcode.auditor
      tables1List.value[10].content = qrcode.reportDate
      tables2List.value = qrcodelist
    })
}
getData()
</script>
<style>
/* 全局重置 - 打印优先 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "SimSun", "宋体", serif;
}
/* 打印根容器 */
.qrcode-print-wrapper {
  width: 210mm; /* A4宽度 */
  min-height: 297mm; /* A4高度 */
  margin: 0 auto;
  padding: 5mm 4mm;
  font-size: 13px;
  line-height: 1.2;
}
/* 头部区域 */
.header-section {
  margin-bottom: 4px;
}
.title {
  font-size: 24px;
  font-weight: bold;
  color: #000;
  margin: 3px 0;
  text-align: center;
}
.qrcode-img {
  width: 90px;
  height: 90px;
  display: block;
  margin: 0 auto 4px;
}
/* 基础信息表格 */
.basic-info-table {
  width: 100%;
  margin-bottom: 4px;
}
.basic-info-table table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #000;
}
.basic-title-cell {
  width: 170px;
  text-align: right;
  padding: 2px 4px;
  font-weight: 500;
  color: #000;
  border: 1px solid #000;
  font-size: 12px;
}
.basic-content-cell {
  width: calc(100% - 170px);
  padding: 2px 4px;
  border: 1px solid #000;
  color: #000;
  font-size: 12px;
}
/* 报告编号 */
.report-title {
  color: #000;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  margin: 3px 0;
}
.report-number {
  color: #000;
  font-size: 14px;
  margin: 3px 0 4px 0;
  padding-left: 4px;
}
/* 明细表格容器 */
.detail-table-container {
  width: 100%;
  page-break-inside: auto !important;
  page-break-after: auto;
}
/* 明细表格 */
.detail-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 12px;
}
.detail-table th, .detail-table td {
  border: 1px solid #000;
  padding: 2px 4px;
  text-align: center;
  color: #000;
  white-space: pre-wrap;
  word-break: break-all;
}
.detail-table th {
  color: #000;
  font-weight: bold;
  border-bottom: 2px solid #000;
  font-size: 13px;
}
/* 备注区域 */
.remarks {
  width: 100%;
  padding: 4px;
  font-size: 12px;
  line-height: 1.3;
  border: 1px solid #000;
  border-top: none;
  color: #000;
}
/* ========== 打印专属样式 ========== */
@media print {
  @page {
    size: A4 portrait;
    margin: 4mm;
  }
  body * {
    visibility: hidden;
  }
  .qrcode-print-wrapper, .qrcode-print-wrapper * {
    visibility: visible;
  }
  .qrcode-print-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    padding: 4mm;
  }
  tr {
    page-break-inside: avoid;
    page-break-after: auto;
  }
  thead {
    display: table-header-group;
  }
  table, th, td {
    border: 1px solid #000 !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  html, body {
    width: 210mm;
    height: 297mm;
    overflow: visible;
  }
}
/* 屏幕显示样式 */
@media screen {
  .qrcode-print-wrapper {
    box-shadow: 0 0 5px #ccc;
    margin: 20px auto;
    background: white;
  }
  .detail-table-container {
    overflow-x: auto;
  }
}
</style>
